export const STRATEGY_TYPE_LABELS: Record<string, string> = {
  FIXED_AMOUNT: 'Fixed Amount',
  PERCENTAGE_BASED: 'Percentage Based',
  NEVER_BUDGE: 'Never Budge',
  ESCALATION: 'Escalation',
  ACCEPT_UP_TO_MAX: 'Accept Up To Max',
  ALWAYS_ACCEPT: 'Always Accept',
  ALWAYS_DECLINE: 'Always Decline',
  SMART_PRICING: 'Smart Pricing',
  AB_TEST: 'A/B Test',
  CONDITIONAL: 'Conditional',
};
